import constants from "../../constants.js";

import {
  EnhancedPolicyRulesConditionsItemFn,
  EnhancedPolicyRulesConditionsFn,
} from '../forms/conditions.js';

const conditionsDataAtValue = "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex.";
const routeParamId = "debtorId";
const endpoint = "Debtors";

export const ItineraryPolicyEnhancedPolicyRulesConditionsItem = EnhancedPolicyRulesConditionsItemFn(conditionsDataAtValue, routeParamId, endpoint);
export const ItineraryPolicyEnhancedPolicyRulesConditions = EnhancedPolicyRulesConditionsFn(conditionsDataAtValue);

export const ItineraryPoliciesProfileAttributeSourceType = {
  displayName: "Profile Attribute Type",
  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex.ProfileSource",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "ProfileAttributeSourceType",
};
  
export const ItineraryPoliciesProfileAttributesItem = {
  displayName: "Profile Attribute",
  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesProfileAttributeSourceType,
    ItineraryPolicyEnhancedPolicyRulesConditions
  ],
  endpoint: endpoint,
  routeParamId: routeParamId,
  removeParamId: "ItinPolProfileAttributesItemIndex",
  canDelete: true,
};
  
export const ItineraryPoliciesProfileAttributesItems = {
  displayName: "Profile Attributes",
  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes",
  displayAs: constants.DISPLAY_AS.GRID,
  copyWithoutCopyText: true,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesProfileAttributesItem,
  gridCols: [
    { name: "Profile Source Type", key: "ProfileSource" },
    { name: "Info", key: "ConditionInfo" },
  ],
};



// WEBPACK FOOTER //
// ./src/config/components/debtors/profileAttribute.js